'use strict';

angular.module('schoolLinqApp').factory('dialogHelper', [
	'$uibModal',
	'$location',
	'$mdPanel',
	'Idle',
	'navigationService',
	'ngxRouter',
	function ($uibModal, $location, $mdPanel, Idle, navigationService, ngxRouter) {
		let canceledRoute = undefined;
		// if a route is canceled in NGX, the "next" url is not available to AJS
		navigationService.routeCanceled$.subscribe((route) => {
			canceledRoute = route.url;
		});

		function dirtyDialog(isDirtyFunction, undoFunction, backFunction, acceptFunction, actionWord) {
			if (!actionWord) {
				actionWord = 'Exit';
			}
			if (isDirtyFunction() || isABootstrapModalOpen()) {
				$uibModal
					.open({
						template: require('@ajs/templates/exit-dialog.tpl.html'),
						backdrop: 'static',
						keyboard: false,
						controller: [
							'$scope',
							'$uibModalInstance',
							function ($scope, modalInstance) {
								$scope.actionWord = actionWord;
								angular.extend($scope, {
									cancel: function () {
										modalInstance.close();
									},
									exit: function () {
										modalInstance.close('reset');
									},
								});
							},
						],
					})
					.result.then(function (reset) {
						if (reset) {
							if (undoFunction) {
								undoFunction();
							}
							acceptFunction();
						} else {
							if (backFunction) {
								backFunction();
							}
						}
					});
			} else {
				acceptFunction();
			}
		}

		function openMessageBox(messageOrTitle, messageDetail, messageDetailArray, messageIconType, closeFunction) {
			// messageOrTitle will be the main message or Title in larger font.
			// messageDetail will be another message in smaller font.
			// messageArray will be a list of string messages in smaller font.
			// messageIconType is what icon you want to be displayed.  'Info' or 'Warning'

			$uibModal
				.open({
					template: require('@ajs/templates/warning-message-dialog.html'),
					backdrop: 'static',
					keyboard: false,
					controller: [
						'$scope',
						'$uibModalInstance',
						function ($scope, msgBoxInstance) {
							// this will listen for route changes (like the user clicking the browsers Back button)
							// and ignore them so the user will stay on the modal.
							$scope.$on('$locationChangeStart', function (event) {
								event.preventDefault();
							});

							$scope.message = null;
							$scope.messageDetail = null;
							$scope.messageDetailList = null;
							$scope.messageType = 'Warning';

							if (!_.isUndefined(messageOrTitle) && messageOrTitle !== null) {
								$scope.message = messageOrTitle;
							}
							if (!_.isUndefined(messageDetail) && messageDetail !== null) {
								$scope.messageDetail = messageDetail;
							}
							if (!_.isUndefined(messageDetailArray) && messageDetailArray !== null) {
								$scope.messageDetailList = messageDetailArray;
							}
							if (!_.isUndefined(messageIconType) && messageIconType !== null) {
								$scope.messageType = messageIconType;
							}

							angular.extend($scope, {
								cancel: function () {
									msgBoxInstance.close();
								},
							});
						},
					],
				})
				.result.then(function () {
					if (closeFunction) {
						closeFunction();
					}
				});

			return;
		}

		function yesnoMessageBox(messageOrTitle, messageDetail, messageDetailArray, messageIconType, yesFunction, noFunction, yesWord, noWord) {
			// messageOrTitle will be the main message or Title in larger font.
			// messageDetail will be another message in smaller font.
			// messageArray will be a list of string messages in smaller font.
			// messageIconType is what icon you want to be displayed.  'Question', 'Info', 'Warning' or 'Error'

			$uibModal
				.open({
					template: require('@ajs/templates/yesno-message-dialog.html'),
					backdrop: 'static',
					keyboard: false,
					controller: [
						'$scope',
						'$uibModalInstance',
						function ($scope, msgBoxInstance) {
							// this will listen for route changes (like the user clicking the browsers Back button)
							// and ignore them so the user will stay on the modal.
							$scope.$on('$locationChangeStart', function (event) {
								event.preventDefault();
							});

							$scope.message = null;
							$scope.messageDetail = null;
							$scope.messageDetailList = null;
							$scope.messageType = 'Question';
							$scope.yesWord = yesWord || 'YES';
							$scope.noWord = noWord || 'NO';
							if (!_.isUndefined(messageOrTitle) && messageOrTitle !== null) {
								$scope.message = messageOrTitle;
							}
							if (!_.isUndefined(messageDetail) && messageDetail !== null) {
								$scope.messageDetail = messageDetail;
							}
							if (!_.isUndefined(messageDetailArray) && messageDetailArray !== null) {
								$scope.messageDetailList = messageDetailArray;
							}
							if (!_.isUndefined(messageIconType) && messageIconType !== null) {
								$scope.messageType = messageIconType;
							}

							angular.extend($scope, {
								cancel: function () {
									msgBoxInstance.close(false);
								},

								yes: function () {
									msgBoxInstance.close(true);
								},
							});
						},
					],
				})
				.result.then(function (response) {
					if (response === true) {
						yesFunction();
					} else {
						if (noFunction) {
							noFunction();
						}
					}
				});
		}

		function reportModal(reportUrl, blob, filename) {
			$uibModal.open({
				template: require('@ajs/templates/report-modal.html'),
				backdrop: 'static',
				keyboard: false,
				windowClass: 'app-modal-window-autoWidth',
				controller: [
					'$scope',
					'$sce',
					'$uibModalInstance',
					function ($scope, $sce, modalInstance) {
						// this will listen for route changes (like the user clicking the browsers Back button)
						// and ignore them so the user will stay on the modal.
						$scope.$on('$locationChangeStart', function (event) {
							event.preventDefault();
						});

						$scope.showView = 0;
						$scope.message = null;

						if (window.navigator.msSaveOrOpenBlob) {
							window.navigator.msSaveOrOpenBlob(blob, filename);
							$scope.message = "Your browser does not support embedded PDF viewing! Click 'Open' below to view the PDF.";
						} else {
							$scope.content = $sce.trustAsResourceUrl(reportUrl);
						}

						angular.extend($scope, {
							cancel: function () {
								modalInstance.close();
							},
						});
					},
				],
			});
		}

		function isABootstrapModalOpen() {
			return $('.modal.in').length > 0;
		}

		function isMdPanelModalOpen() {
			var mdPanels = $('.md-panel-is-showing');
			return mdPanels.length > 0;
		}

		function saveSuccessful(openFrom, closeTo, displayText) {
			if (!displayText) {
				displayText = 'Save Successful!';
			}

			const template =
				'' +
				'<div layout="row" class="save-successful" layout-margin="" layout-align="start center"> ' +
				'    <div layout="column" flex="15">' +
				'        <i class="fa fa-check-circle fa-3x" aria-hidden="true"></i>' +
				'    </div>' +
				'    <div layout="column" >' +
				'        <md-label style="font-size: 24px;">' +
				displayText +
				'</md-label>' +
				'    </div>' +
				'</div>';

			const controller = [
				'$uibModalInstance',
				function (successModal) {
					setTimeout(function () {
						successModal.close();
					}, 2000);
				},
			];

			$uibModal.open({
				template: template,
				backdrop: 'static',
				keyboard: false,
				controller: controller,
				windowClass: 'save-successful-modal',
			});
		}

		/* #############################################################################################################
 * #############################################################################################################
*  function actionDialog(params)

    params = {
        mainText: '',                   // (Required) String - Main Text for Dialog - 22px font-size
        detailText: '',                 // (Optional) String - Detail Text for Dialog - 16px font-size
        detailTextArray: [],            // (Optional) Array  - Detail Text as lines in an array. Each line object requires 'text:' Property. Used for line breaks by iterating through the array. - 16px font-size
        iconType: 'Warning',            // (Optional) String - icon to display in dialog ( 'Warning', 'Question', 'Info', 'Error')
        cancelButton: {                 // Object - Setup for the Left Button
            text: 'CANCEL',             // String - text for the left button
            func: null                  // (Optional) Function - called when the cancelButton is pressed.
        },
        acceptButton: {                 // (Optional) Object - Setup for the Right Button
            text: 'OK',                 // String - text for the right button
            func: null                  // (Optional) Function - called when the acceptButton is pressed.
        },
    };
* #############################################################################################################
* ############################################################################################################# */

		function actionDialog(params) {
			if (!params) {
				return;
			}

			const defaults = {
				iconType: 'Warning',
				cancelButton: {
					text: 'CANCEL',
				},
				acceptButton: {
					text: 'OK',
				},
			};

			if (_.isUndefined(params.iconType)) {
				params.iconType = 'Warning';
			}
			if (_.isUndefined(params.detailTextArray)) {
				params.detailTextArray = [];
			}
			if (_.isUndefined(params.cancelButton)) {
				params.cancelButton = defaults.cancelButton;
			}
			if (_.isUndefined(params.acceptButton)) {
				params.acceptButton = defaults.acceptButton;
			}

			const controller = [
				'$scope',
				'$uibModalInstance',
				function ($scope, actionModal) {
					$scope.vm = params;

					angular.extend($scope, {
						accept: function () {
							actionModal.close();
							if (!_.isUndefined($scope.vm.acceptButton.func) && _.isFunction($scope.vm.acceptButton.func)) {
								return $scope.vm.acceptButton.func();
							}
						},
						cancel: function () {
							actionModal.close();
							if (!_.isUndefined($scope.vm.cancelButton.func) && _.isFunction($scope.vm.cancelButton.func)) {
								return $scope.vm.cancelButton.func();
							}
						},
					});
				},
			];

			$uibModal.open({
				template: require('@ajs/templates/dialog-helper-action-dialog.html'),
				backdrop: 'static',
				keyboard: false,
				controller: controller,
			});
		}

		function routeChange(isDirtyFunction, acceptFunction, event, newUrl, oldUrl, actionWord) {
			if ((isMdPanelModalOpen() === true && event) || confirmChangesWindowOpen) {
				event.preventDefault();
				return;
			}
			if (Idle.isExpired()) {
				return;
			}

			if (typeof actionWord !== 'string') {
				actionWord = 'Exit';
			}
			// Navigate to newUrl if the form isn't dirty
			if (isDirtyFunction === undefined) {
				if (!isABootstrapModalOpen()) return;
			} else {
				if (!isDirtyFunction() && !isABootstrapModalOpen()) return;
			}

			confirmChangesWindowOpen = true;
			$uibModal
				.open({
					template: require('@ajs/templates/exit-dialog.tpl.html'),
					backdrop: 'static',
					keyboard: false,
					controller: [
						'$scope',
						'$uibModalInstance',
						function ($scope, modalInstance) {
							$scope.actionWord = actionWord;
							angular.extend($scope, {
								cancel: function () {
									modalInstance.close();
								},
								exit: function () {
									modalInstance.close('reset');
								},
							});
						},
					],
				})
				.result.then(function (reset) {
					confirmChangesWindowOpen = false;
					if (reset) {
						acceptFunction();
						// get the index to the end of the server base (scheme://host:port)
						const idx = newUrl.indexOf('/', newUrl.indexOf('//') + 2);
						const newPath = newUrl.substr(idx);
						const path = canceledRoute ? canceledRoute : newPath.replace(/^.*\/\/[^\/]+[/]+[#]/, '');

						setTimeout(() => {
							// both navigations are needed, keep them sync'ed
							$location.path(path);
							ngxRouter.navigateByUrl(path);
						}, 33);
						canceledRoute = undefined;
					}
				});

			// prevent navigation by default since we'll handle it
			// once the user selects a dialog option
			event.preventDefault();
			return;
		}

		//TODO: routeChange is firing twice after the Angular11 migration.  No cause has been found yet.
		//This hack prevents the confirm changes window from opening twice.
		let confirmChangesWindowOpen = false;

		return {
			dirtyDialog: dirtyDialog,
			openMessageBox: openMessageBox,
			yesnoMessageBox: yesnoMessageBox,
			reportModal: reportModal,
			saveSuccessful: saveSuccessful,
			actionDialog: actionDialog,
			routeChange: routeChange,
			confirmChangesWindowOpen,
		};
	},
]);
